import Vue from 'vue';
import Router from 'vue-router';
//import LeituradeMapaVSL from '../components/LeituradeMapaVSL.vue';
//import KirvanoUpsellVideo from '../components/KirvanoUpsellVideo.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    /*{
      path: '/leitura',
      name: 'LeituradeMapaVSL',
      component: LeituradeMapaVSL,
      props: true
    },*/
    {
      path: '/enviodosdados',
      name: 'HelloWorld',
      component: () => import(/* webpackChunkName: "helloworld" */ '../components/HelloWorld.vue'),
      props: true
    },
    {
      path: '/pGwZSDj',
      name: 'PaginaPrincipal',
      component: () => import('@/components/PaginaPrincipal.vue'),
      props: true
    },
    {
      path: '/obrigado-correo',
      name: 'ObrigadoCorreo',
      component: () => import('@/components/ObrigadoCorreo'),
      props: false
    },
    
],
});
